import React, { useState } from "react";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { createAppQueryClient, createIdbPersister } from "../offline/createQueryClient";

const persister = createIdbPersister();

/**
 * TanStack Query + IndexedDB persistence for teacher offline modules.
 */
export default function QueryProvider({ children }) {
  const [queryClient] = useState(() => createAppQueryClient());

  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister,
        maxAge: 1000 * 60 * 60 * 24 * 7,
        dehydrateOptions: {
          shouldDehydrateQuery: (query) => {
            const key = query.queryKey[0];
            return (
              key === "classStudents" ||
              key === "classMeta" ||
              key === "attendanceSubmissions" ||
              key === "marksSubmissions" ||
              key === "schoolNotices"
            );
          },
        },
      }}
    >
      {children}
    </PersistQueryClientProvider>
  );
}
